import { render, staticRenderFns } from "./CenterIndex.vue?vue&type=template&id=e8194862&scoped=true"
import script from "./CenterIndex.vue?vue&type=script&lang=js"
export * from "./CenterIndex.vue?vue&type=script&lang=js"
import style0 from "./CenterIndex.vue?vue&type=style&index=0&id=e8194862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8194862",
  null
  
)

export default component.exports